export default __webpack_public_path__ + "static/media/regulatory--no-parking--g3.ced5e03c.png";